import script from "./ChatSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSidebar.vue?vue&type=style&index=0&id=4229e38e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4229e38e"]])

export default __exports__